// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"496":"0b0b5833","620":"e912cba3","718":"8cbf8967","996":"6187ab86"}[chunkId] + ".chunk.css";
};